module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAAXNSR0IArs4c6QAAAFRQTFRFAAAAqqqqtra2oqKinp6em5ubn5+fmpqam5ubmpqam5ubmZmZm5ubmZmZmpqamZmZmpqampqampqamZmZmZmZmZmZmpqampqamZmZmpqampqamZmZaYrFBwAAABt0Uk5TAAMHCxUcJTVATFluenuDh5yptdPc5O/09fn+RONKswAAAG5JREFUKM+9yUcCQDAABdEQBFGj+/e/pxIhzZJZziPkm6qXnyP3fjpgoD6oAdSenyw7LIkLAkfC+RlkmfXD/oI+NKGEqjB+PN8wxTq0eGq1n0IvvX/QGdAFCjjM+PWj0YIxktDArjk/Wx1YGfmjDcR3Ec9cj/6VAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/ic_jiantou.png
// module id = Mg5K
// module chunks = 1